export default function (dom, opts) {
    let options = {

        showFormCls: 'show-form',
        itemSel: '[data-filter-target]',
        singleFilterSel: '[data-filter]',

        hideFromParentSel: '.widget-select.hide-following-field',
        hideFromParentSelect: '.hide-following-field select',

        ...opts
    };

    const filterSingle = Array.from(dom.querySelectorAll(options.singleFilterSel));
    const formItem = Array.from(dom.querySelectorAll(options.itemSel));

    const seekField = dom.querySelector(options.hideFromParentSel);
    const seekFields = Array.from(dom.querySelectorAll(options.hideFromParentSel));
    const seekFieldSelect = Array.from(dom.querySelectorAll(options.hideFromParentSelect));
    const seekFieldSingleSelect = dom.querySelector(options.hideFromParentSelect);

    let filterValue = "";

    function init() {
        filterRetailer();
        hideFieldCond();
    }

    function hideFieldCond() {
        seekFieldSelect.forEach(select => {
            select.addEventListener('change', (e) => {
                let current = e.target;
                let closest = current.closest('.widget-select')
                let nextField = closest.nextElementSibling;
                let closestInput = nextField.querySelector('input');

                nextField.style.display = 'block';
                closestInput.setAttribute('required', '');
                closestInput.value = '';
                if (current.selectedIndex !== 0) {
                    nextField.style.display = 'none';
                    closestInput.removeAttribute('required');
                    closestInput.value = '-';
                }
            })
        })


        window.addEventListener('load', ()=> {
            seekFieldSelect.forEach(select => {
                let closest = select.closest('.widget-select')
                let nextField = closest.nextElementSibling;
                let closestInput = nextField.querySelector('input');

                if (select.selectedIndex !== 0) {
                    nextField.style.display = 'none';
                    closestInput.removeAttribute('required');
                    closestInput.value = '-';
                }
            })
        })
    }

    function filterRetailer() {
        filterSingle.forEach(filter => {
            filter.addEventListener('click', () => {
                applyFilter(filter.dataset.name)
            })
        });
    }

    function applyFilter(value) {
        let delay = 0;
        filterValue = value;
        formItem.forEach(filter => {
            // create array with filterable values - data-value
            const values = filter.dataset.filterTarget.split(/,\s*/);

            // search for current filter value
            const active = filterValue ? values.includes(filterValue) : true;
            filter.classList.remove(options.showFormCls);

            if (active) {
                setTimeout(() => {
                    filter.style.animationDelay = `${delay}ms`;
                    filter.classList.add(options.showFormCls);
                    delay += 100;
                }, 0)
            }

        })
    }

    init()

}
